class MediaManager {
  private isSnapped = false;
  private isSnapping = false;

  private currentVideoTime = 0;
  private isVideoLooped = false;
  private SNAP_TIME_THRESHOLD  = 3; // in seconds

  createThumbnailFromVideo(playerRef) {
    return new Promise((resolve, reject) => {
      let stateUpdate = (state) => {
        const { currentTime } = state;
        this.isVideoLooped = currentTime < this.currentVideoTime;
        this.currentVideoTime = currentTime;
        if (this.isSnapping) { return; }
        const result = this.snapImage(state);
        if (result && !this.isSnapped) {
          this.isSnapped = true;
          try {
            result.canvas.toBlob((blob) => resolve({
              blob,
              path: result.image,
              duration: result.duration
            }));
          } catch(e) { reject(e); }
        } else { this.isSnapped = false; }
      };
      playerRef.subscribeToStateChange(stateUpdate);
    });
  }

  private snapImage(state) {
    this.isSnapping = true;
    const canvas = document.createElement('canvas');
    const { duration, currentTime } = state;
    canvas.width = state.videoWidth;
    canvas.height = state.videoHeight;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = "#000000";
      (ctx as any).drawImage(document.querySelector('.video-react-video'), 0, 0, canvas.width, canvas.height);
      const image = canvas.toDataURL();
      const imageSizeThreshold = this.isVideoLooped || currentTime > this.SNAP_TIME_THRESHOLD ? 0 : 5000; // 5000 is around the minimum image size when nothing snapped
      const success = image.length > imageSizeThreshold;
      this.isSnapping = false;
      if (success) {
        return { image, canvas, duration };
      }
    }
    return null;
  };
}

const mediaManager = new MediaManager();
export default mediaManager;